import { Application } from 'stimulus';
import { registerControllers } from '~/javascripts/helpers/stimulus_controllers_finder';

const application = Application.start();
const controllers = import.meta.globEager('../../web/components/**/controller.js');
registerControllers(application, controllers);
